import { useEffect, useMemo, useState } from 'react';
import { api, DATA_CHANGED } from './api/apiService';
import { useI18n } from './i18n/I18nProvider';

const copy = {
  pl: { title: 'Powiadomienia', empty: 'Brak powiadomień', allRead: 'Oznacz wszystkie jako przeczytane', assignment: 'Zmieniono przypisanie transferu', updated: 'Zmieniono transfer', created: 'Dodano transfer', projectUpdated: 'Zmieniono projekt', projectCreated: 'Dodano projekt', availability: 'Zmieniono dostępność kierowcy', open: 'Otwórz' },
  en: { title: 'Notifications', empty: 'No notifications', allRead: 'Mark all as read', assignment: 'Transfer assignment changed', updated: 'Transfer changed', created: 'Transfer added', projectUpdated: 'Project changed', projectCreated: 'Project added', availability: 'Driver availability changed', open: 'Open' },
  de: { title: 'Benachrichtigungen', empty: 'Keine Benachrichtigungen', allRead: 'Alle als gelesen markieren', assignment: 'Fahrtzuweisung geändert', updated: 'Fahrt geändert', created: 'Fahrt hinzugefügt', projectUpdated: 'Projekt geändert', projectCreated: 'Projekt hinzugefügt', availability: 'Fahrerverfügbarkeit geändert', open: 'Öffnen' },
};

function label(kind, text) {
  return ({ TRANSFER_ASSIGNED: text.assignment, TRANSFER_UPDATED: text.updated, TRANSFER_CREATED: text.created, PROJECT_UPDATED: text.projectUpdated, PROJECT_CREATED: text.projectCreated, AVAILABILITY_UPDATED: text.availability })[kind] || text.title;
}

export default function NotificationInbox({ compact = false, onUnreadChange }) {
  const { locale } = useI18n();
  const text = copy[locale] || copy.en;
  const [state, setState] = useState({ data: [], unread_count: 0, loading: true });

  const load = async () => {
    try { setState((previous) => ({ ...previous, loading: true })); const result = await api.notifications(); setState({ ...result, loading: false }); }
    catch (_) { setState((previous) => ({ ...previous, loading: false })); }
  };
  useEffect(() => {
    load();
    const refresh = () => load();
    window.addEventListener(DATA_CHANGED, refresh);
    const timer = window.setInterval(refresh, 60000);
    return () => { window.removeEventListener(DATA_CHANGED, refresh); window.clearInterval(timer); };
  }, []); // The inbox is intentionally refreshed independently of page data.

  const unread = Number(state.unread_count || 0);
  useEffect(() => { onUnreadChange?.(unread); }, [onUnreadChange, unread]);
  const visible = useMemo(() => (state.data || []).slice(0, compact ? 6 : 20), [state.data, compact]);
  const open = async (item) => {
    if (!item.read_at) { try { await api.markNotificationRead(item.id); } catch (_) { /* navigation remains useful */ } }
    if (item.link_path) window.location.assign(item.link_path);
    else load();
  };
  const markAll = async () => { try { await api.markAllNotificationsRead(); await load(); } catch (_) { /* retry on next refresh */ } };

  return <section className="notification-inbox" aria-label={text.title}>
    <div className="notification-inbox-heading"><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 10a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4" /></svg>{text.title}</span>{unread > 0 && <b>{unread > 99 ? '99+' : unread}</b>}</div>
    {unread > 0 && <button type="button" className="notification-read-all" onClick={markAll}>{text.allRead}</button>}
    <div className="notification-list">
      {!state.loading && visible.length === 0 && <p>{text.empty}</p>}
      {visible.map((item) => <button type="button" key={item.id} className={item.read_at ? 'notification-item' : 'notification-item unread'} onClick={() => open(item)}>
        <strong>{label(item.kind, text)}</strong>
        <span>{item.context?.route || item.context?.project || item.context?.driver || ''}{item.context?.date ? ` · ${item.context.date}` : ''}</span>
      </button>)}
    </div>
  </section>;
}
